import { useAgentStore } from "../../store/agentStore";
import AgentForm from "../../components/agents/AgentForm";

import { toast } from "react-toastify";

import {
  useCreateAgentMutation,
  useUpdateAgentMutation,
} from "../../queries/agents/useAgentsQuery";


export default function ManageAgent({ onSuccess, onClose = () => {} }) {
  const {  selectedAgent, setSelectedAgent } = useAgentStore();

  const isEdit = !!selectedAgent?.agent?.id;

  const { mutate: createAgent, isPending: creating } = useCreateAgentMutation();

  const { mutate: updateAgent, isPending: updating } = useUpdateAgentMutation();

  const handleSubmit = (payload) => {
    if (isEdit) {
      updateAgent(
        { id: selectedAgent.agent?.id || selectedAgent.id, data: payload },
        {
          onSuccess: (data) => {
            toast.success("Agent updated successfully");
            // ✅ update only agent, keep rest
            setSelectedAgent((prev) => ({
              ...prev,
              agent: data
            }));
  
            onSuccess?.();
          },
          onError: (error) => {
            toast.error(error.message || "Failed to update agent");
          },
        }
      );
    } else {
      createAgent(payload, {
        onSuccess: (data) => {
          toast.success("Agent created successfully");
          // ✅ create minimal structure
          setSelectedAgent({
            agent: data,
            domains: [],
            properties: [],
            leads: [],
            scoring_config: null,
            settings: null
          });
          onSuccess?.(data.id);
        },
        onError: (error) => {
          toast.error(error.message || "Failed to create agent");
        },
      });
    }
  };
  return (
    <AgentForm
      initialData={selectedAgent?.agent || null}
      onSubmit={handleSubmit}
      onClose={onClose}
      isLoading={creating || updating}
    />
  );
}
